import { render, staticRenderFns } from "./model-create-2.vue?vue&type=template&id=7df7c9d4&scoped=true&"
import script from "./model-create-2.vue?vue&type=script&lang=js&"
export * from "./model-create-2.vue?vue&type=script&lang=js&"
import style0 from "./model-create-2.vue?vue&type=style&index=0&id=7df7c9d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df7c9d4",
  null
  
)

export default component.exports